// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"22fa09ff","208":"766dee49","328":"070a2c57","496":"a2ca8ef6","512":"d82b7f04","544":"3665aa64","556":"899b0434","692":"ec135402","800":"4eb91c09","808":"195ee794","864":"94128fef","912":"68f3afb4"}[chunkId] + ".chunk.js";
};